/***********add product****************** */
const wrapper = document.getElementById('products-wrapper');
const template = document.getElementById('product-template');

function updateProductNumbers() {

    const items = wrapper.querySelectorAll('.product-item');

    items.forEach(function(item, index){

        item.querySelector('h3').textContent =
            'Product #' + (index + 1);

        const remove = item.querySelector('.remove-product');

        if(remove){

            remove.style.display =
                items.length === 1 ? 'none' : '';

        }

    });

}

function addProduct() {

    let html = template.innerHTML;

    const count =
        wrapper.querySelectorAll('.product-item').length + 1;

    html = html.replace('__INDEX__', count);

    wrapper.insertAdjacentHTML('beforeend', html);

    updateProductNumbers();

}

document.addEventListener('click', function(e){
    if(!e.target.matches('#add-product')){
        return;
    }
    addProduct();
});

document.addEventListener('click', function(e){
    if(!e.target.matches('.remove-product')){
        return;
    }

    const item = e.target.closest('.product-item');

    item.remove();

    updateProductNumbers();

});


document.addEventListener('input', function(e){

    if(!e.target.matches('input[name="quantity[]"]')){
        return;
    }

    if(e.target.value < 1){

        e.target.value = 1;

    }

});

/*********** country********* */

function initCountrySync() {

    const country = document.getElementById('country');
    Array.from(country.options).forEach(option => {
        if (option.value === '---') {
            option.remove();
        }
    });
    const delivery = document.getElementById('delivery-country');

    if (!country || !delivery) return;

    const syncCountry = () => {
        delivery.value = country.options[country.selectedIndex].text;
    };

    country.addEventListener('change', syncCountry);

    syncCountry();
}

initCountrySync();


let dialingCodes = {};

async function loadCountryCodes() {
    const response = await fetch(window.countryCodeFile);
    dialingCodes = await response.json();
    buildPhoneCodeDropdown();
}

loadCountryCodes();

function buildPhoneCodeDropdown() {
    const phoneCode = document.getElementById('phone-code');
    phoneCode.innerHTML = '';
    Object.entries(dialingCodes).forEach(([iso, code]) => {
        const option = document.createElement('option');
        option.value = code;
        option.textContent = `${iso} ${code}`;
        phoneCode.appendChild(option);
    });

    // Default Australia
    phoneCode.value = '+61';
}


const form = document.getElementById('shipping-quote-form');

/************** Multi Step **************/
const steps = document.querySelectorAll('.quote-step');
const progressBar = document.querySelector('.quote-progress-bar');
const currentStepText = document.getElementById('current-step');
let currentStep = 0;

function showStep(index){
    steps.forEach(function(step){
        step.classList.remove('was-validated');
        step.classList.remove('active');
    });

    steps[index].classList.add('active');
    currentStep = index;
    progressBar.style.width =
        ((index + 1) / steps.length) * 100 + '%';
    currentStepText.textContent = index + 1;
   
}

function validateCurrentStep(){
    steps[currentStep].classList.add('was-validated');
    const fields =
        steps[currentStep].querySelectorAll(
            'input, select, textarea'
        );
    for(const field of fields){
        if(field.required && !field.checkValidity()){
            field.reportValidity();
            field.focus();
            return false;
        }
    }
    return true;
}

document.addEventListener('click',function(e){
    if(!e.target.matches('.next-step')){
        return;
    }
    if(!validateCurrentStep()){
        return;
    }
    if(currentStep < steps.length - 1){
        showStep(currentStep + 1);
    }
});

document.addEventListener('click',function(e){
    if(!e.target.matches('.prev-step')){
        return;
    }
    if(currentStep > 0){
        showStep(currentStep - 1);
    }
});

showStep(0);

/******************submit******** */

form.addEventListener('submit', function (e) {
    e.preventDefault();
    form.classList.add('was-validated');
    if (!form.checkValidity()) {
        const firstInvalid = form.querySelector(':invalid');

        if (firstInvalid) {
            firstInvalid.focus({
                preventScroll: true
            });

            firstInvalid.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        }
        form.reportValidity();
        return;
    }
    // TODO
    // ==========================
    const payload = {
        first_name: document.querySelector('[name="first_name"]').value,
        last_name: document.querySelector('[name="last_name"]').value,
        email: document.querySelector('[name="email"]').value,
        phone_code: document.getElementById('phone-code').value,
        phone_number: document.getElementById('phone-number').value,
        street: document.querySelector('[name="street_address"]').value,
        city: document.querySelector('[name="city"]').value,
        postcode: document.querySelector('[name="postcode"]').value,
        country: document.getElementById('delivery-country').value,
        vehicle_details: document.querySelector('[name="vehicle_details"]').value,
        shipping_method: document.querySelector('input[name="shipping_method"]:checked')?.value || '',
        customer_type: document.querySelector('input[name="customer_type"]:checked')?.value || '',
        notes: document.querySelector('[name="notes"]').value || '',
        products: []
  };
    document.querySelectorAll('.product-item').forEach(function(item){
        payload.products.push({
            product:
                item.querySelector('[name="product_name[]"]').value,
            sku: item.querySelector('.product-sku-value').value || '',
            quantity:
                item.querySelector('[name="quantity[]"]').value
        });
    });

    const submitButton = form.querySelector('.quote-footer .quote-submit');
    submitButton.classList.add('loading');
    document.querySelector('.prev-step').style.display = 'none';
    console.log('========== SUBMIT DATA ==========');
console.log(payload);
console.log('First Name:', payload.first_name);
console.log('Last Name:', payload.last_name);
console.log('Email:', payload.email);
console.log('Phone Code:', payload.phone_code);
console.log('Phone Number:', payload.phone_number);
console.log('=================================');
    fetch('https://api.vikorindustries.com.au/send-email.php',{
        method:'POST',
        headers:{
            'Content-Type':'application/json'
        },
        body:JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(data => {
        submitButton.classList.remove('loading');
        if (!data.success) {
            alert(data.message);
            return;
        }
        document.querySelector('.quote-progress').style.display = 'none';
        document.querySelector('.quote-progress-text').style.display = 'none';
        document.querySelector('.shipping-quote__hero').style.display = 'none';
        form.style.display = 'none';
        document.getElementById('quote-success').style.display = 'block';
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    })
    .catch(error => {
        submitButton.classList.remove('loading');
        console.error(error);
        alert('Something went wrong. Please try again.');
    });

});

form.querySelectorAll('input, select, textarea').forEach(field => {
    field.addEventListener('input', () => {
        if (field.checkValidity()) {
            field.classList.remove('is-invalid');
        }
    });
});

/******************FAQ****************** */

document.querySelectorAll('.quote-faq details').forEach(detail => {

    detail.addEventListener('toggle', function () {

        if (!this.open) return;

        document.querySelectorAll('.quote-faq details').forEach(item => {

            if (item !== this) {
                item.open = false;
            }

        });

    });

});

/**************** saerch fill product**** */
let searchTimeout;
document.addEventListener('input', function(e){
    if(!e.target.matches('.product-search')){
        return;
    }
    const field = e.target.closest('.product-search-field');

    field.querySelector('.product-name').value = '';
    field.querySelector('.product-handle').value = '';
    field.querySelector('.product-sku-value').value = '';

    clearTimeout(searchTimeout);
    const keyword = e.target.value.trim();
    if(keyword.length < 2){
        const results =
            e.target.parentElement.querySelector('.product-results');

        results.style.display='none';
        results.innerHTML='';
        return;
    }

    searchTimeout = setTimeout(function(){
        searchProducts(keyword,e.target);
    },300);

});

async function searchProducts(keyword,input){
    const results =
        input.parentElement.querySelector('.product-results');
    results.innerHTML='Loading...';
    results.style.display='block';
    try{
        const response = await fetch(
            `/search/suggest.json?q=${encodeURIComponent(keyword)}&resources[type]=product&resources[limit]=6`
        );
        const data = await response.json();
        renderProducts(
            data.resources.results.products,
            results,
            input
        );
    }
    catch(error){
        console.log(error); 
    }
}

function renderProducts(products,container,input){
    if(products.length===0){
        container.innerHTML='<div class="product-empty">No products found.</div>';
        return;
    }

    let html='';
    products.forEach(function(product){
        html+=`
        <div
            class="product-item-result"
            data-title="${product.title}"
            data-handle="${product.handle}">
            <img
                src="${product.image}"
                alt="${product.title}">
            <div class="product-info">
                <div class="product-title">
                    ${product.title}
                </div>
            </div>
        </div>
        `;
    });
    container.innerHTML=html;
}


document.addEventListener('click', async function(e) {
    const item = e.target.closest('.product-item-result');
    if (!item) {
        return;
    }
    const field = item.closest('.product-search-field');
   
    field.querySelector('.product-name').value = item.dataset.title;
    field.querySelector('.product-handle').value = item.dataset.handle;
    field.querySelector('.product-results').style.display = 'none';

    try {
        const response = await fetch(`/products/${item.dataset.handle}.js`);
        if (!response.ok) {
            throw new Error('Unable to load product.');
        }
        const product = await response.json();
        const sku = product.variants[0]?.sku || '';
        field.querySelector('.product-sku-value').value = sku;
        field.querySelector('.product-search').value = sku ? `${sku} - ${item.dataset.title}` : item.dataset.title;
    }
    catch (error) {
        console.error(error);
        field.querySelector('.selected-product-sku').innerHTML = '';
    }

});

